"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnyDataTypeImpl = void 0;
var AnyDataTypeImpl = /** @class */function () {
  function AnyDataTypeImpl() {
    /**
     * The constructor function creating the value type
     */
    this.valueClass = AnyDataTypeImpl;
  }
  /**
   * @inheritdoc
   */
  AnyDataTypeImpl.prototype.name = function () {
    return 'any';
  };
  return AnyDataTypeImpl;
}();
exports.AnyDataTypeImpl = AnyDataTypeImpl;